import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../base/ui/components/web/Button';
import { BUTTON_TYPES } from '../../../base/ui/constants.web';
import { autoAssignToBreakoutRooms, setPersistentBreakoutAutoAssign } from '../../actions.any';
export const AutoAssignButton = ({ className }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const persistentAutoAssign = useSelector((state) => state['features/breakout-rooms'].persistentAutoAssign || false);
    const onAutoAssign = useCallback(() => {
        if (persistentAutoAssign) {
            dispatch(setPersistentBreakoutAutoAssign(false));
        }
        else {
            dispatch(setPersistentBreakoutAutoAssign(true));
            dispatch(autoAssignToBreakoutRooms());
        }
    }, [dispatch, persistentAutoAssign]);
    return (React.createElement(Button, { accessibilityLabel: persistentAutoAssign ? t('breakoutRooms.actions.disableAutoAssign') : t('breakoutRooms.actions.autoAssign'), className: `${className} auto-assign-button`, fullWidth: true, labelKey: persistentAutoAssign ? 'breakoutRooms.actions.disableAutoAssign' : 'breakoutRooms.actions.autoAssign', onClick: onAutoAssign, type: persistentAutoAssign ? BUTTON_TYPES.DESTRUCTIVE : BUTTON_TYPES.TERTIARY }));
};
